import { memo, useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import {
  ApiOverrideIndicator,
  initializeApiOverrides,
} from "@hunkware-ui/common";

import "../shared/assets/styles/main.scss";

import { useAppRoutes } from "./model";
import { useErrorBoundary } from "../features/error-boundary";

export const App = memo(() => {
  useErrorBoundary();

  const appRoutes = useAppRoutes();

  useEffect(() => {
    // Initialize API URL overrides from query params (for PR testing)
    initializeApiOverrides();
  }, []);

  const router = createBrowserRouter(appRoutes);

  return (
    <>
      <RouterProvider router={router} />
      <ApiOverrideIndicator />
    </>
  );
});
